import { FETCH_LOCKER_PLAN_REQUEST } from './types'
import { takeLatest } from 'redux-saga/effects'
import { fetchLockerPlanSaga } from './sagas'

export function* watchFetchLockerPlanSaga() {
  yield takeLatest(FETCH_LOCKER_PLAN_REQUEST, fetchLockerPlanSaga)
}
